module.exports = __webpack_public_path__ + "img/header-bg.ebbeac7f.png";